import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MerchantService } from '../../services/merchant.service';
import { ParticipantService } from '../../services/participant.service';
import { UserDataStoreService } from '../../services/user-data-store.service';
import { AuthenticationService } from '../../services/authentication.service';
import { CreateResult } from '../../models/create-result';
import { ReportService } from '../../services/report.service';
import { MerchantReportDTViewModel } from '../../models/merchant-report-dt-view-model';

@Component({
  selector: 'app-merchant-report-registration',
  templateUrl: './merchant-report-registration.component.html',
  styleUrls: ['./merchant-report-registration.component.scss']
})
export class MerchantReportRegistrationComponent implements OnInit {

  public submitted = false;
  raiseDanger: boolean;
  danger: string;
  public MerchantRegistrationGroup: FormGroup;
  public createResult: CreateResult;
  raiseErrors: boolean;
  errorMessage: string;
  participantId: number;

  constructor(
    private _router: Router,
    private route: ActivatedRoute,
    private _userDataStore: UserDataStoreService,
    private _authenticationService: AuthenticationService,
    private _modalService: NgbModal,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _toastService: ToastrService,
    private _formBuilder: FormBuilder,
    private _merchantService: MerchantService,
    private _reportService: ReportService,
    private _http: HttpClient,
    private _participantService: ParticipantService,
    private _modal: NgbActiveModal) { }

  ngOnInit() {
    this.participantId = this._userDataStore.selectedParticipant.id
    this.MerchantRegistrationGroup = this._formBuilder.group({
      merchantNumber: ['', [Validators.required, Validators.minLength(15), Validators.maxLength(15)]],
      shopName: ['', [Validators.required, Validators.maxLength(23)]]
    });
  }

  public close() {
    this._modal.close();
  }

  async save() {
    debugger;
    this.submitted = true;
    if (!this.MerchantRegistrationGroup.valid) {
      this.raiseDanger = true;
      this.danger = "The form is invalid. Please ensure that all mandatory fields are filled with the required input.";
    }
    else {
      this.raiseDanger = false;
      this._ngxUiLoaderService.start();

      //var merchantReoprt: MerchantReportDTViewModel = {
      //  clientId: "4",
      //  description: this.MerchantRegistrationGroup.controls["merchantNumber"].value,
      //  merchantGroupId: "0",
      //  merchantID: this.MerchantRegistrationGroup.controls["merchantNumber"].value,
      //  merchantNumber: this.MerchantRegistrationGroup.controls["merchantNumber"].value,
      //  participantId: this.participantId,
      //  usnNumber: this.MerchantRegistrationGroup.controls["merchantNumber"].value,
      //  id: 0,
      //  clientName: ""
      //};
      debugger;
      this.createResult = await this._reportService.registerMerchant(this.MerchantRegistrationGroup.controls["merchantNumber"].value, this.MerchantRegistrationGroup.controls["shopName"].value);

      if (this.createResult.success) {
        this._toastService.success(this.createResult.message, "Success");
        this.close();
      } else {
        this._toastService.error(this.createResult.message, "Error");
        this.raiseErrors = true;
        this.errorMessage = this.createResult.message;
      }


      this._ngxUiLoaderService.stop();
    }
  }
}
